import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Table, Thead, Tr, Th, Td} from './Table';
import TextField from 'material-ui/TextField';

// import Pagination from './Pagination';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import Pagination from 'react-js-pagination';
import constants from '../../parameters/constants';
import {withNamespaces} from 'react-i18next';

const PaginationHolder = styled.div`
  margin-top: -20px;
  text-align: right;

  .pagination li > a {
    color: ${constants.primaryColor} !important;
  }

  .pagination .active a,
  .pagination .active a:hover {
    color: #fff !important;
    background-color: ${constants.primaryColor} !important;
    border-color: ${constants.primaryColor} !important;
  }
`;

const SearchHolder = styled.div`
  margin-bottom: 20px;
  float: right;
  width: 250px;
`;

class EntityTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      filterVal: '',
      filteredRows: [],
    };
  }

  _filterRows = (filterVal, rows) => {
    if (!rows) {
      rows = [];
    }
    let regex = new RegExp(filterVal, 'i');
    let {filterString} = this.props.tableConfig;
    let filtered = rows.filter((entity) => {
      let entityText = filterString ? filterString(entity) : Object.values(entity).toString();
      return entityText.search(regex) > -1;
    });
    this.setState({filteredRows: filtered, filterVal: filterVal});
  };

  _filter = (event) => {
    event.preventDefault();
    this.setState({currentPage: 1});
    this._filterRows(event.target.value, this.props.data);
  };

  componentWillMount() {
    this._updateRows(this.props.data);
  }

  componentWillReceiveProps(newProps) {
    this._updateRows(newProps.data);
  }

  _updateRows = (data) => {
    this._filterRows(this.state.filterVal, data);
  };

  _paginationChange = (page) => {
    this.setState({currentPage: page});
  };
  render() {
    let {t, tableConfig, totalRows, searchEnabled = true, onRowClicked} = this.props;
    let nothingFound;
    let pagination;
    let paginationRows = totalRows;
    if (this.state.totalRows == null) {
      paginationRows = this.state.filteredRows.length;
    }

    if (paginationRows > tableConfig.maxRows) {
      pagination = (
        <PaginationHolder>
          <Pagination
            activePage={this.state.currentPage}
            itemsCountPerPage={tableConfig.maxRows}
            totalItemsCount={paginationRows}
            pageRangeDisplayed={5}
            onChange={this._paginationChange}
          />
        </PaginationHolder>
      );
    }

    let search;

    if (searchEnabled) {
      search = (
        <SearchHolder>
          <TextField
            fullWidth
            type='text'
            name='search'
            placeholder={t('table.search')}
            onChange={this._filter}
            value={this.state.filterVal}
          />
        </SearchHolder>
      );
    }

    let page = this.state.currentPage;

    return (
      <div>
        <ReactTooltip />
        {search}
        <Table style={{margin: '20px 0 10px', width: '100%'}}>
          <Thead>
            <Tr>
              {tableConfig.cols.map((conf, idx) => {
                if (!conf.header || conf.header === '') {
                  return (
                    <Th customWidth={conf.width} key={idx}>
                      &nbsp;
                    </Th>
                  );
                } else {
                  return (
                    <Th customWidth={conf.width} key={idx}>
                      {conf.header}
                    </Th>
                  );
                }
              })}
            </Tr>
          </Thead>
          <tbody>
            {nothingFound}
            {this.state.filteredRows.map((item, idx) => {
              if (idx >= (page - 1) * tableConfig.maxRows && idx < page * tableConfig.maxRows) {
                return (
                  <Tr key={idx} onClick={() => onRowClicked && onRowClicked(item)} selectable={!!onRowClicked}>
                    {tableConfig.cols.map((conf, colIdx) => {
                      let value;
                      if (conf.valueKey === '*') {
                        value = item;
                      } else {
                        value = item[conf.valueKey];
                      }

                      if (conf.tooltip) {
                        return (
                          <Td key={idx + '_' + colIdx} hasMore={conf.hasMore}>
                            <p data-tip={conf.tooltip}>{conf.method(value, item)}</p>
                          </Td>
                        );
                      }
                      return (
                        <Td key={idx + '_' + colIdx} hasMore={conf.hasMore}>
                          {conf.method(value, item)}
                        </Td>
                      );
                    })}
                  </Tr>
                );
              }
              return null;
            })}
          </tbody>
        </Table>
        {pagination}
      </div>
    );
  }
}

EntityTable.propTypes = {
  data: PropTypes.array,
  tableConfig: PropTypes.object.isRequired,
  msg: PropTypes.string.isRequired,
  searchEnabled: PropTypes.bool,
  onRowClicked: PropTypes.func,
};

export default withNamespaces()(EntityTable);



// WEBPACK FOOTER //
// ./src/components/table/EntityTable.js